import React from 'react';
import { Link } from 'react-router-dom';

const GatewayTimeoutPage = () => {
  return (
    <div className="error-page">
      <h1>504 Gateway Timeout</h1>
      <p>The server did not receive a timely response from an upstream server. Please try again later.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default GatewayTimeoutPage;
